import { render, staticRenderFns } from "./NextStepsTab.vue?vue&type=template&id=586c871a&scoped=true"
import script from "./NextStepsTab.vue?vue&type=script&lang=ts"
export * from "./NextStepsTab.vue?vue&type=script&lang=ts"
import style0 from "./NextStepsTab.vue?vue&type=style&index=0&id=586c871a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586c871a",
  null
  
)

export default component.exports